module.exports = __webpack_public_path__ + "img/chat_icon_selected.204e5a18.svg";